module.exports = __webpack_public_path__ + "static/img/image003.317a331.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image003.png
// module id = ejp/
// module chunks = 1